var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 768,
    viewBox: "0 0 1440 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 768,
    fill: "#3B6B35"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1760_106618",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 1440,
    height: 767
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 1.09082,
    width: 1440,
    height: 766.909,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1760_106618)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1760_106618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709.517 837.648C709.517 1128.84 481.676 1362.57 203.456 1362.57C-74.7652 1362.57 -302.606 1128.84 -302.606 837.648C-302.606 546.451 -74.7652 312.727 203.456 312.727C481.676 312.727 709.517 546.451 709.517 837.648Z",
    stroke: "url(#paint0_radial_1760_106618)",
    strokeOpacity: 0.7,
    strokeWidth: 80
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1760_106618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M615.61 835.36C615.61 1072.39 430.13 1262.79 203.455 1262.79C-23.2201 1262.79 -208.7 1072.39 -208.7 835.36C-208.7 598.332 -23.2201 407.935 203.455 407.935C430.13 407.935 615.61 598.332 615.61 835.36Z",
    stroke: "url(#paint1_radial_1760_106618)",
    strokeOpacity: 0.65,
    strokeWidth: 60
  })), /*#__PURE__*/React.createElement("path", {
    d: "M517.18 835.358C517.18 1016.66 375.451 1161.3 203.456 1161.3C31.4598 1161.3 -110.269 1016.66 -110.269 835.358C-110.269 654.055 31.4598 509.418 203.456 509.418C375.451 509.418 517.18 654.055 517.18 835.358Z",
    stroke: "url(#paint2_radial_1760_106618)",
    strokeOpacity: 0.81,
    strokeWidth: 80
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1760_106618",
    x: -352.606,
    y: 262.727,
    width: 1112.12,
    height: 1149.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1760_106618"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1760_106618",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1760_106618",
    x: -248.7,
    y: 367.935,
    width: 904.31,
    height: 934.851,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1760_106618"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1760_106618",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1760_106618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.098 862.363) rotate(88.8301) scale(752.207 727.117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.654764,
    stopColor: "#E2F6FC",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B7D6",
    stopOpacity: 0.84
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1760_106618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(191.019 855.373) rotate(88.8301) scale(609.074 588.759)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.654764,
    stopColor: "#E2F6FC",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B7D6",
    stopOpacity: 0.84
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1760_106618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(193.507 851.368) rotate(88.8301) scale(487.26 471.007)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.654764,
    stopColor: "#E2F6FC",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B7D6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterBackground);
export default __webpack_public_path__ + "static/media/register_background.b75167da4b998d77da635b7562c5cfd6.svg";
export { ForwardRef as ReactComponent };